"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMutationLoader = exports.StyledMutationLoaderWrapper = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importStar(require("styled-components"));
const flexbox_1 = require("../flexbox");
const gradientAnimation = (0, styled_components_1.keyframes) `
  0% {
    background-position: 0% 50%;
  }
  10% {
    background-position: 10% 50%;
  }
  20% {
    background-position: 20% 52%;
  }
  30% {
    background-position: 30% 55%;
  }
  40% {
    background-position: 40% 60%;
  }
  50% {
    background-position: 50% 65%;
  }
  60% {
    background-position: 60% 70%;
  }
  70% {
    background-position: 70% 75%;
  }
  80% {
    background-position: 80% 78%;
  }
  90% {
    background-position: 90% 80%;
  }
  100% {
    background-position: 100% 50%;
  }
`;
exports.StyledMutationLoaderWrapper = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  position: relative;
  top: 0;
  left: 0;
  width: 100vw;
  min-height: 88px;
  padding: 0 48px;

  background: linear-gradient(
    90deg,
    #110000 0%,
    #950e2d 4.85%,
    #a27a80 10.08%,
    #a28591 14.82%,
    #a29997 19.42%,
    #a2a39a 24.65%,
    #8f9ea1 29.46%,
    #8cc4c3 34.54%,
    #679ca9 39.35%,
    #396c89 46.04%,
    #154670 52.87%,
    #689daa 60.47%,
    #8cc4c3 68.55%,
    #8f9fa2 74.48%,
    #a3a39a 79.85%,
    #a29897 85.07%,
    #a28591 89.67%,
    #870d28 94.94%,
    #110000 100%
  );
  animation: ${gradientAnimation} 15s cubic-bezier(1, 1, 1, 1) infinite;
  background-size: 700% 100%;
  z-index: 9999;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    max-width: 100%;
    width: ${({ percent }) => percent + '%'};
    height: 4px;
    background-color: ${theme_1.grayScale[50]};
    opacity: 0.75;
  }
  ${({ customStyles }) => customStyles || {}}

  @media (max-width: 768px) {
    padding: 20px;
  }
`;
exports.StyledMutationLoader = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  z-index: 999;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
//# sourceMappingURL=styles.js.map